function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

function setAccordionContentHeight(details) {
  const content = details.querySelector('.accordion__content');
  if (!content) return;
  content.style.setProperty('--accordion-content-height', `${content.scrollHeight}px`);
}

function clearAccordionAnimationState(details) {
  details.classList.remove('is-opening', 'is-closing', 'is-animating');
  const content = details.querySelector('.accordion__content');
  if (content) {
    content.style.removeProperty('--accordion-content-height');
    content.style.height = '';
  }
}

function scrollAccordionToReveal(details, summary) {
  if (!details || !summary) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const content = details.querySelector('.accordion__content');
  const rect = summary.getBoundingClientRect();
  const viewportHeight = window.innerHeight;
  const padding = 200;
  let targetTop = window.scrollY + rect.top - padding;

  if (content) {
    const contentHeight = content.scrollHeight;
    if (contentHeight + padding * 2 <= viewportHeight) {
      const bottomVisible = rect.top + contentHeight + padding <= viewportHeight;
      if (!bottomVisible) {
        targetTop = window.scrollY + rect.top + contentHeight + padding - viewportHeight;
      }
    }
  }

  window.scrollTo({ top: Math.max(targetTop, 0), behavior: 'smooth' });
}

function openProductAccordion(details, summary) {
  if (!details || details.classList.contains('is-animating')) return;
  details.setAttribute('open', '');
  summary.setAttribute('aria-expanded', 'true');
  setAccordionContentHeight(details);
  details.classList.remove('is-closing');
  details.classList.add('is-opening', 'is-animating');
  const content = details.querySelector('.accordion__content');
  if (!content) {
    clearAccordionAnimationState(details);
    return;
  }
  const onOpenEnd = () => {
    content.removeEventListener('animationend', onOpenEnd);
    content.style.height = 'auto';
    clearAccordionAnimationState(details);
    requestAnimationFrame(() => scrollAccordionToReveal(details, summary));
  };
  content.addEventListener('animationend', onOpenEnd);
}

function closeProductAccordion(details, summary) {
  if (!details || details.classList.contains('is-animating')) return;
  if (!details.hasAttribute('open')) return;
  setAccordionContentHeight(details);
  details.classList.remove('is-opening');
  details.classList.add('is-closing', 'is-animating');
  const content = details.querySelector('.accordion__content');
  if (!content) {
    details.removeAttribute('open');
    summary.setAttribute('aria-expanded', 'false');
    clearAccordionAnimationState(details);
    return;
  }
  const onCloseEnd = () => {
    content.removeEventListener('animationend', onCloseEnd);
    details.removeAttribute('open');
    summary.setAttribute('aria-expanded', 'false');
    clearAccordionAnimationState(details);
  };
  content.addEventListener('animationend', onCloseEnd);
}

const summaryBtns = document.querySelectorAll('[id^="Details-"] summary');

summaryBtns.forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  if (summary.classList.contains('header__menu-item--primary')) {
    const parent = summary.parentNode;
    const details = summary.closest('details');
    let closeTimeout;
    let closingTimeout;

    parent.addEventListener('mouseenter', () => {
      // Cancel any pending close so re-entering never replays the open animation.
      clearTimeout(closeTimeout);
      clearTimeout(closingTimeout);
      details.classList.remove('is-closing');
      if (!details.hasAttribute('open')) {
        details.setAttribute('open', '');
      }
      summary.setAttribute('aria-expanded', 'true');
    });

    parent.addEventListener('mouseleave', () => {
      // Short grace period: the mega panel sits below the menu item with an
      // empty strip between them, so the cursor briefly leaves the details
      // hover region when moving into the panel. Delaying the close animation
      // avoids the open/close flicker when crossing that gap.
      clearTimeout(closeTimeout);
      closeTimeout = setTimeout(() => {
        details.classList.add('is-closing');
        closingTimeout = setTimeout(() => {
          details.removeAttribute('open');
          summary.setAttribute('aria-expanded', 'false');
          details.classList.remove('is-closing');
        }, 300);
      }, 150);
    });

    summary.addEventListener('click', e => e.preventDefault());
  } else {
    summary.addEventListener('click', (event) => {
      // Disable toggle for mega columns (prevent closing the details)
      if (summary.classList.contains('header__mega-column-title')) {
        event.preventDefault();
        return;
      }

      const isProductAccordion = summary.closest('.product__accordion');
      const currentTarget = event.currentTarget;
      const currentDetails = currentTarget.closest('details');
      const shouldOpen = !currentDetails.hasAttribute('open');

      if (isProductAccordion) {
        event.preventDefault();

        summaryBtns.forEach((summaryBtn) => {
          const ariaControls = summaryBtn.getAttribute('aria-controls');
          if (ariaControls && ariaControls.indexOf('ProductAccordion') > -1) {
            if (summaryBtn !== currentTarget) {
              const otherDetails = summaryBtn.closest('details');
              closeProductAccordion(otherDetails, summaryBtn);
            }
          }
        });

        if (shouldOpen) {
          openProductAccordion(currentDetails, currentTarget);
        } else {
          closeProductAccordion(currentDetails, currentTarget);
        }

        return;
      }

      currentTarget.setAttribute('aria-expanded', shouldOpen);

      summaryBtns.forEach((summaryBtn) => {
        const ariaControls = summaryBtn.getAttribute('aria-controls');
        if (ariaControls && ariaControls.indexOf('ProductAccordion') > -1) {
          if (summaryBtn !== currentTarget) {
            summaryBtn.setAttribute('aria-expanded', false);
            summaryBtn.parentNode.removeAttribute('open');
          }
        }
      });
    });
  }

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  if (!container) {
    return
  }
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.changeInProgress = false;
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();

    if (!this.changeInProgress) {
      const previousValue = this.input.value;

      event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
      if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
      this.blockMultipleClicks(event);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }

  blockMultipleClicks(event) {
    this.changeInProgress = true;
    if (event.target.name == 'plus') {
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', true);
      setTimeout(() => {
        this.changeInProgress = false;
        buttonPlus.classList.toggle('disabled', false);

      }, 500)
    }
    if (event.target.name == 'minus') {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', true);
      setTimeout(() => {
        this.changeInProgress = false;
        buttonMinus.classList.toggle('disabled', false);
      }, 500)
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

function fetchConfigAux(type = 'json', config = {}) {
  /** @type {Headers} */
  const headers = { 'Content-Type': 'application/json', Accept: `application/${type}`, ...config.headers };

  if (type === 'javascript') {
    headers['X-Requested-With'] = 'XMLHttpRequest';
    delete headers['Content-Type'];
  }

  return {
    method: 'POST',
    headers: /** @type {HeadersInit} */ (headers),
    body: config.body,
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector):not(.reset__button)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    if (summaryElement.classList.contains('menu-drawer__accordion-summary')) return;

    const parentMenuElement = detailsElement.closest('.has-submenu');
    const selectedTabMenu = detailsElement.closest('.menu-drawer__accordion-content');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        selectedTabMenu && selectedTabMenu.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    const selectedTabMenu = detailsElement.closest('.menu-drawer__accordion-content');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    selectedTabMenu && selectedTabMenu.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.closest('.modal-close-intensity')) {
          this.hide();
        }
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    document.body.classList.add('overflow-hidden-extra');
    setTimeout(() => {
      this.setAttribute('open', '');
      // if (popup) popup.loadContent();
      // trapFocus(this, this.querySelector('[role="dialog"]'));
      window.pauseAllMedia({ pauseThumbnailVideos: true });
    }, 250)

    document.body.classList.add('overflow-hidden');
    if (this.querySelector('.modal-content')) {
      this.querySelector('.modal-content').classList.remove('animate-slideToBottomPopup');
      this.querySelector('.modal-content').classList.add('animate-slideFromBottomPopup');
    }
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.classList.remove('overflow-hidden-extra');

    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    setTimeout(() => {
      this.removeAttribute('open');
      removeTrapFocus(this.openedBy);
      window.pauseAllMedia({ resumeThumbnailVideos: true });
    }, 250)
    if (this.querySelector('.modal-content')) {
      this.querySelector('.modal-content').classList.remove('animate-slideFromBottomPopup');
      this.querySelector('.modal-content').classList.add('animate-slideToBottomPopup');
    }
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.windowSize = window.innerWidth;
    this.windowSizeScrollUpdate = 750;
    this.isMobile = this.windowSize < this.windowSizeScrollUpdate ? true : false;
    this.isHorizontal = this.slider.classList.contains('slider--horizontal') ? true : false;
    this.mobileDotsCounter = this.querySelector('.slider-counter--dots-wrapper');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  connectedCallback() {
    //runs once component is mounted in the page
    if (this.mobileDotsCounter && this.isMobile) {
      this.mobileDotsInit();
    }
  }

  initPages() {
    if (this.isHorizontal) {
      // calculations for Horizontal slider 
      this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
      if (this.sliderItemsToShow.length < 2) return;
      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
      this.slidesPerPage = Math.floor(
        (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
      );
      this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage;
    } else {
      //calculations for Vertical slider
      this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientHeight > 0);
      if (this.sliderItemsToShow.length < 2) return;
      this.sliderItemOffset = this.sliderItemsToShow[1].offsetTop - this.sliderItemsToShow[0].offsetTop;
      this.slidesPerPage = Math.floor(
        (this.slider.clientHeight - this.sliderItemsToShow[0].offsetTop) / this.sliderItemOffset
      );
      this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    }

    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;

    if (this.isHorizontal) {
      this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;
      if (this.currentPageElement && this.pageTotalElement) {
        this.currentPageElement.textContent = this.currentPage;
        this.pageTotalElement.textContent = this.totalPages;
      }

      if (this.enableSliderLooping) return;

      if (this.isSlideVisibleX(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
        this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.prevButton.removeAttribute('disabled');
      }

      if (this.isSlideVisibleX(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
        this.nextButton.setAttribute('disabled', 'disabled');
      } else {
        this.nextButton.removeAttribute('disabled');
      }

    } else {
      this.currentPage = Math.round(this.slider.scrollTop / this.sliderItemOffset) + 1;
      if (this.currentPageElement && this.pageTotalElement) {
        this.currentPageElement.textContent = this.currentPage;
        this.pageTotalElement.textContent = this.totalPages;
      }

      if (this.enableSliderLooping) return;

      if (this.isSlideVisibleY(this.sliderItemsToShow[0]) && this.slider.scrollTop === 0) {
        this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.prevButton.removeAttribute('disabled');
      }
      if (this.isSlideVisibleY(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
        this.nextButton.setAttribute('disabled', 'disabled');
      } else {
        this.nextButton.removeAttribute('disabled');
      }
    }

    //call dots update
    if (this.currentPage != previousPage) {
      //update dots
      if (this.mobileDotsCounter) {
        if (this.isMobile) {
          this.updateMobileDots(this.currentPage)
        }
      }
      //end

      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    // video play pause on slide update

    if (this.currentPage == 2) {
      if (this.querySelector('.media-type-video')) {
        let videoEL = this.querySelector('.media-type-video video');
        videoEL.play();
        videoEL.setAttribute('autoplay', 'true');
        videoEL.setAttribute('loop', 'true');
      }
    }
    else {
      if (this.querySelector('.media-type-video')) {
        let videoEL = this.querySelector('.media-type-video video');
        videoEL.pause();
        videoEL.removeAttribute('autoplay');
        videoEL.removeAttribute('loop');
      }
    }

    if (this.enableSliderLooping) return;

    //to hide products tags in PDP on infographic image
    if (this.currentPage == 2) { //used to becasuse the infograpgic image is on the second slide
      document.querySelector('.product__gallery-slider').classList.add('hide-gallery-tags')
    }
    else {
      document.querySelector('.product__gallery-slider').classList.remove('hide-gallery-tags')
    }
  }

  isSlideVisibleY(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientHeight + this.slider.scrollTop - offset;
    return element.offsetTop + element.clientHeight <= lastVisibleSlide && element.offsetTop >= this.slider.scrollTop;
  }

  isSlideVisibleX(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;

    if (this.isHorizontal) {
      this.slideScrollPosition =
        event.currentTarget.name === 'next'
          ? this.slider.scrollLeft + step * this.sliderItemOffset
          : this.slider.scrollLeft - step * this.sliderItemOffset;
    } else {
      this.slideScrollPosition =
        event.currentTarget.name === 'next'
          ? this.slider.scrollTop + step * this.sliderItemOffset
          : this.slider.scrollTop - step * this.sliderItemOffset;
    }

    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    if (this.isHorizontal) {
      this.slider.scrollTo({
        left: position,
      });
    }
    else {
      this.slider.scrollTo({
        top: position,
      });
    }
  }

  mobileDotsInit() {
    //add dots to component
    const slider = this.mobileDotsCounter.querySelector('.slider-counter--dots');
    slider.innerHTML = ``;
    this.sliderItemsToShow.forEach((item, index) => {
      if (index == 0) {
        slider.innerHTML += `<div class="dot active" data-index="${index}"></div>`;
      }
      else {
        slider.innerHTML += `<div class="dot" data-index="${index}"></div>`;
      }
    })
  }

  updateMobileDots(currentPage = 0) {
    const slider = this.mobileDotsCounter.querySelector('.slider-counter--dots');
    const target = slider.querySelector(`.dot[data-index="${currentPage - 1}"]`)
    if (!slider || !target) return;

    // Get the target element's offset relative to the container
    const containerScrollLeft = target.offsetLeft - slider.offsetLeft;

    slider.querySelectorAll('.dot').forEach((el) => {
      if (el.dataset.index == currentPage - 1) {
        el.classList.add('active')
      }
      else {
        el.classList.remove('active')
      }
    })

    //check if scroll is needed _
    const sliderRect = slider.getBoundingClientRect();
    const dotRect = target.getBoundingClientRect();

    if (dotRect.left < sliderRect.left || dotRect.right > sliderRect.right) {
      // Scroll the slider to bring the active dot into view
      slider.scrollTo({
        left: containerScrollLeft,
        behavior: 'smooth'
      });
    }
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollTop + this.sliderFirstItemNode.clientHeight * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollTop + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollTop +
      this.sliderFirstItemNode.clientHeight *
      (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(`Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('visibility-hidden', pricePerItemSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination)
          inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
    if (pricePerItem) pricePerItem.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
            // updatePriceIgTest();
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

// New DS Animated Modal Popup - 5/9/2023
class AnimatedModalButton extends HTMLElement {
  constructor() {
    super();
    this.bisButtonClass = 'js-back-in-stock';
    this.bisModalProductTitleClass = 'back-in-stock__product-title';
    this.bisModalProductVendorClass = 'back-in-stock__product-vendor';
    this.bisModalFormEmailInput = 'back-in-stock__form input[type="email"]';
    this.bisModalFormButton = 'back-in-stock__form button';
    this.bisModalErrorMessage = 'back-in-stock__form-error-message';
    this.bisModalSuccessMessage = 'back-in-stock__form-success-message';
    this.modalToggleClass = 'show';
    this.button = this.querySelector('button');
    this.toggleModalHandler();
  }

  toggleModalHandler() {
    this.button.addEventListener('click', (event) => {
      event.preventDefault();
      const button = event.currentTarget;
      const modalTargetAttribute = button.dataset.modalTarget;
      const modal = document.querySelector(modalTargetAttribute);

      if (modal) {
        this.toggleModal(modal);
        this.updateBackInStockModal(button, modal);
      }
    });
  }

  updateBackInStockModal(button, modal) {
    if (button.classList.contains(this.bisButtonClass)) {
      const variantId = button.dataset.variantId;
      const productTitle = button.dataset.productTitle;
      const productVendor = button.dataset.productVendor;

      const modalProductTitle = modal.querySelector('.' + this.bisModalProductTitleClass);
      const modalProductVendor = modal.querySelector('.' + this.bisModalProductVendorClass);
      const modalFormEmailInput = modal.querySelector('.' + this.bisModalFormEmailInput);
      const modalFormButton = modal.querySelector('.' + this.bisModalFormButton);
      const modalSuccessMessage = modal.querySelector('.' + this.bisModalSuccessMessage);
      const modalErrorMessage = modal.querySelector('.' + this.bisModalErrorMessage);

      if (productTitle) {
        modalProductTitle.innerHTML = productTitle;
      }

      if (productVendor) {
        modalProductVendor.innerHTML = productVendor;
      }

      if (variantId) {
        modalFormButton.setAttribute('data-variant-id', variantId);
      }

      //Reset Modal Form
      modalFormEmailInput.classList.remove('error');
      modalSuccessMessage.classList.add('hidden');
      modalErrorMessage.classList.add('hidden');
      modal.querySelector('.back-in-stock__form').classList.remove('hidden')
    }
  }

  toggleModal(modal) {
    modal.classList.toggle(this.modalToggleClass);
    let animatedEl = modal.querySelector('.animate-slideFromBottomPopup') || modal.querySelector('.animate-slideToBottomPopup');
    if (animatedEl) {
      animatedEl.classList.remove('animate-slideToBottomPopup');
      animatedEl.classList.add('animate-slideFromBottomPopup');
    }
  }
}

customElements.define('ds-button', AnimatedModalButton);

class AnimatedModalPopup extends HTMLElement {
  constructor() {
    super();
    this.closeButton = this.querySelectorAll('[aria-label="Close"]');
    this.modalContent = this.querySelector('.ds-modal__content');
    this.init();
  }

  init() {
    this.closeModalHandler();
    this.outsideClickHandler();
  }

  closeModalHandler() {
    if (this.closeButton && this.closeButton.length > 0) {
      this.closeButton.forEach(button => {
        button.addEventListener('click', (event) => {
          if (button.closest('.animate-slideFromBottomPopup')) {
            let el = event.target.closest('.animate-slideFromBottomPopup');
            document.body.classList.remove('overflow-hidden');
            document.body.classList.remove('overflow-hidden-extra');
            el.classList.remove('animate-slideFromBottomPopup')
            el.classList.add('animate-slideToBottomPopup');
          }
          setTimeout(() => {
            document.body.classList.remove('overflow-hidden');
            this.classList.remove('show');

            if (this.modalContent.closest('#free-product-modal-gift')) {
              document.querySelector('#free-product-modal-gift').classList.remove('step-1');
              document.querySelector('#free-product-modal-gift').classList.add('step-2');
            }
          }, 500)
        });
      });
    }
  }

  outsideClickHandler() {
    this.addEventListener('click', (event) => {
      if (this.modalContent && !this.modalContent.contains(event.target)) {

        if (this.querySelector('.animate-slideFromBottomPopup')) {
          let el = this.querySelector('.animate-slideFromBottomPopup');
          document.body.classList.remove('overflow-hidden');
          document.body.classList.remove('overflow-hidden-extra');
          el.classList.remove('animate-slideFromBottomPopup')
          el.classList.add('animate-slideToBottomPopup');
        }
        setTimeout(() => {
          document.body.classList.remove('overflow-hidden');
          this.classList.remove('show');

          if (this.modalContent.closest('#free-product-modal-gift')) {
            document.querySelector('#free-product-modal-gift').classList.remove('step-1');
            document.querySelector('#free-product-modal-gift').classList.add('step-2');
          }
        }, 500)
      }

    });
  }
}

customElements.define('ds-modal', AnimatedModalPopup);

function updateCartCountBubbleBottomIsland() {
  if (!document.querySelector('[data-cart-qty]')) return;

  let quantity = document.querySelector('[data-cart-qty]').dataset.cartQty;
  document.querySelector('#bottom-island-cart-count-buble .cart-count-bubble').dataset.items = quantity;
  document.querySelector('#bottom-island-cart-count-buble .cart-count-bubble').innerHTML = `
    <span aria-hidden="true">${quantity}</span>
    <span class="visually-hidden">${quantity} items</span>`
}

// Update add to cart buttons if the cart limit is reached
function cartLimitReached(cartQty) {
  let cartQuantityNumber = parseInt(document.querySelector('.drawer__top-bar').dataset.cartQty) || 0;
  const selectors = ['.quick-add__submit:not(.free-p-btn)', '.product-form__submit', '.product-layering__add-to-cart'];
  const quantityPlusButton = document.querySelectorAll('.quantity__button[name="plus"]');
  const skipBisSelector = 'js-back-in-stock';

  const disableAddToCartBtn = (button) => {
    if (button.querySelector('span')) {
      button.querySelector('span').innerHTML = cartProductsLimitText;
      button.setAttribute('disabled', '');
    }
  };

  const enableAddToCartBtn = (button, addToCartText) => {
    if (button.querySelector('span')) {
      const buttonText = button.dataset.content || addToCartText || productAddText;
      if (button.querySelector('.atc-text')) {
        button.querySelector('.atc-text').innerHTML = buttonText;
      }
      else {
        if (button.querySelector('.btn-added-checkmark')) {
          setTimeout(() => {
            button.querySelector('span').innerHTML = buttonText;
          }, 4000);
        }
        else {
          button.querySelector('span').innerHTML = buttonText;
        }
      }
      button.removeAttribute('disabled');
    }
  };

  const setButtonsState = (disable) => {
    for (const selector of selectors) {
      const buttons = document.querySelectorAll(selector);
      if (buttons) {
        buttons.forEach((button) => {
          if (button) {
            if (!button.classList.contains(skipBisSelector)) {
              if (disable) {
                disableAddToCartBtn(button);
              } else {
                if (button.getAttribute('data-btn-text')) {
                  const addToCartText = button.dataset.btnText;
                  enableAddToCartBtn(button, addToCartText);
                } else {
                  enableAddToCartBtn(button);
                }
              }
            }
          }
        });
      }
    }
  };

  if (cartQuantityNumber >= cartProductsLimit || cartQty >= cartProductsLimit) {
    setButtonsState(true);
    if (quantityPlusButton) {
      quantityPlusButton.forEach((button) => {
        button.classList.add('disabled');
        button.setAttribute('disabled', '');
      });
    }
  } else {
    setButtonsState(false);
    if (quantityPlusButton) {
      quantityPlusButton.forEach((button) => {
        button.classList.remove('disabled');
        button.removeAttribute('disabled');
      });
    }
  }

  // console.log('cart qty', cartQuantityNumber)
  // console.log('cart qty limit', cartProductsLimit)
}

// Add Multiple Items/Scents to Cart
add_multiple_scents = (event, productVariantIds) => {
  const eventTarget = event.currentTarget;

  const cartButtonEl = document.getElementById('cart-icon-bubble');
  let cartButtonCountEl = cartButtonEl.querySelector('.cart-count-bubble');
  const countCartItemsData = cartButtonCountEl.dataset.items;

  removeCartLimit = () => {
    const cartLimitTextEl = document.getElementsByClassName('productLimit__cart-limit-text');

    if (cartLimitTextEl && cartLimitTextEl.length > 0) {
      for (var i = 0; i < cartLimitTextEl.length; i++) {
        cartLimitTextEl[i].remove();
      }
    }
  }

  addToCartLoading = () => {
    eventTarget.classList.toggle('loading');
    eventTarget.querySelector('.loading-overlay__spinner').classList.toggle('hidden');
  }

  if (cartButtonEl && countCartItemsData) {
    if (parseInt(countCartItemsData) >= parseInt(cartProductsLimit) - 1) {
      removeCartLimit();

      const cartLimitTextEl = document.createElement('p');
      cartLimitTextEl.classList.add('productLimit__cart-limit-text');
      cartLimitTextEl.innerHTML = 'Cart will be overlimit. Remove 1 item from cart.';

      const itemContent = eventTarget.parentElement.parentElement;
      itemContent.parentNode.insertBefore(cartLimitTextEl, itemContent.nextSibling);
    } else {
      removeCartLimit();
      addToCartLoading();

      const items = [];
      let qty = 1;

      let itemVariantIds = productVariantIds.split(',');

      if (itemVariantIds.length == 1) {
        qty = 3;
      }

      itemVariantIds.forEach(variantId => {
        var itemVariantId = { quantity: qty, id: variantId };
        items.push(itemVariantId);
      });

      const data = {
        items: items,
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname,
        ...(window.hiddenSaleActive ? { attributes: { dsrDiscounts: 'true' } } : { attributes: { dsrDiscounts: 'false' } })
      };

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      })
        .then(response => {
          return response.json();
        })
        .then(response => {

          document.querySelector('cart-drawer').renderContents(response, false, itemVariantIds);

        })
        .finally(() => {
          if (document.querySelector('cart-drawer') && document.querySelector('cart-drawer').classList.contains('is-empty')) document.querySelector('cart-drawer').classList.remove('is-empty');
          eventTarget.classList.remove('loading');
          eventTarget.querySelector('.loading-overlay__spinner').classList.add('hidden');

          updateAddToCartButtonsText(eventTarget);
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    }
  }
}

function updateAddToCartButtonsText(button) {
  if (window.innerWidth < 768) {
    const cartQuantity = document.querySelector('[data-cart-qty]').dataset.cartQty || 0;

    if (cartQuantity < 9) {
      let oldInnerHTMLOfButton = button.innerHTML;
      button.innerHTML += `<svg class='btn-added-checkmark' xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 29 29" fill="none"><path d="M25.9486 14.3081C25.9486 20.7369 20.7369 25.9486 14.3081 25.9486C7.87925 25.9486 2.6676 20.7369 2.6676 14.3081C2.6676 7.87925 7.87925 2.6676 14.3081 2.6676C20.7369 2.6676 25.9486 7.87925 25.9486 14.3081Z" stroke="white" stroke-width="1.43081"/><path d="M9.45789 14.0712L13.0018 17.6151L19.2188 11.3981" stroke="white" stroke-width="1.43081"/></svg>`;
      button.querySelector('span').innerHTML = `<span>AÑADIDO</span>`;
      button.classList.add('button__added-to-cart');

      setTimeout(() => {
        if (document.querySelector('[data-cart-qty]').dataset.cartQty < '9') {
          button.innerHTML = oldInnerHTMLOfButton;
          button.classList.remove('button__added-to-cart');
        }
      }, 4000);
    }
  }
}

// update announcement bar
function updateAnnouncementBar() {
  const topBarQty = parseInt(document.querySelector('.drawer__top-bar')?.dataset.cartQty || '0', 10) || 0;
  const fallbackQty = parseInt(document.querySelector('[data-cart-qty]')?.dataset.cartQty || '0', 10) || 0;
  const cartQty = Math.max(topBarQty, fallbackQty);
  const progressBarAll = document.querySelectorAll('.progress-bar');
  const promoProgressBars = document.querySelectorAll('.announcement__bar-default .promo-progress-bar');
  const promoProgressBarsRows = document.querySelectorAll('.announcement__bar-default .progress-bar__row');

  const promoEmptyMessages = document.querySelectorAll('.announcement__bar-default .progress_bar__empty');
  const promoBarContainers = document.querySelectorAll('.promo-announcement-bar-container');

  if (!progressBarAll.length) return;

  const cappedQty = Math.min(cartQty, 5);

  progressBarAll.forEach((progressBar) => {
    const progressBarStates = progressBar.dataset.progressBarStates;

    if (!progressBarStates) return;

    const progressBarStatesArray = progressBarStates.split(',');
    const progressBarClass = progressBarStatesArray[Math.min(cartQty, progressBarStatesArray.length - 1)];

    progressBar.classList.remove(...progressBarStatesArray);
    progressBar.classList.add(progressBarClass);

    // Update data-qty attribute - CSS handles all styling from here
    progressBar.dataset.qty = cappedQty;
  });

  // Keep default promo milestone bar in sync with cart updates.
  promoProgressBars.forEach((promoProgressBar) => {
    promoProgressBar.dataset.qty = cappedQty;
    promoProgressBar.classList.toggle('show', cartQty > 0);
  });

  //

  promoProgressBarsRows.forEach((promoProgressBar) => {
    promoProgressBar.dataset.cartQty = cappedQty > 2 ? 2 : cappedQty;
    promoProgressBar.classList.toggle('show', cartQty > 0);
  });

  promoEmptyMessages.forEach((emptyMessage) => {
    emptyMessage.classList.toggle('show', cartQty === 0);
  });

  promoBarContainers.forEach((container) => {
    container.classList.toggle('show-progress-bar', cartQty > 0);
  });

  applyAnnouncementBarSlider();
  showDynamicPrices();
}

// bundle builder update
async function updateBundleBuilder() {
  // use section rendering API to render bundle list

  if (!document.querySelector('.bundle-builder')) {
    return;
  }

  let sectionId = document.querySelector('.bundle-builder .shopify-section').id.replace('shopify-section-', '')

  let fetchUrl = `${window.Shopify.routes.root}?section_id=${sectionId}`
  let resultFetch = await fetch(fetchUrl);
  let result = await resultFetch.text()

  //update html
  document.querySelector('.bundle-builder__item-list-wrapper').innerHTML = new DOMParser().parseFromString(result, 'text/html').querySelector('.bundle-builder__item-list-wrapper').innerHTML;


  function bundleBuilderScrollInit() {
    //logic for bundle builder arrows scroll

    let leftArrow = document.querySelector('.bundle-builder__item-list-body_arrow.arrow-left');
    let rightArrow = document.querySelector('.bundle-builder__item-list-body_arrow.arrow-right');
    let listContainer = document.querySelector('.bundle-builder__item-list-body-container');
    let listWrapper = document.querySelector('.bundle-builder__item-list-body-wrapper');

    function updateScrollIndicators() {
      const { scrollLeft, scrollWidth, clientWidth } = listWrapper;

      if (scrollLeft > 0) {
        leftArrow.classList.add('show')
      }
      else {
        leftArrow.classList.remove('show')
      }

      if (scrollLeft < scrollWidth - clientWidth) {
        rightArrow.classList.add('show')
      }
      else {
        rightArrow.classList.remove('show')
      }
    }

    listWrapper.addEventListener('scroll', updateScrollIndicators);

    // Initial check for scroll indicators
    updateScrollIndicators();

    // Scroll on indicator click
    listContainer.addEventListener('click', (e) => {

      if (e.target.closest('.bundle-builder__item-list-body_arrow.arrow-left')) {
        listWrapper.scrollBy({ left: -150, behavior: 'smooth' });
      }

      if (e.target.closest('.bundle-builder__item-list-body_arrow.arrow-right')) {
        listWrapper.scrollBy({ left: 150, behavior: 'smooth' });
      }
    })
  }

  bundleBuilderScrollInit();
}
// bundle builder update

function extractCookie(name) {
  const cookieValue = `; ${document.cookie}`;
  const cookieParts = cookieValue.split(`; ${name}=`);
  if (cookieParts.length === 2) return cookieParts.pop().split(';').shift();
  return null;
}

function bindRegisterButton() {
  window.addEventListener('click', (e) => {
    if (e.target.closest('.button--register')) {
      const registerKlaviyoPopup = document.querySelector('.klaviyo-lead-capture-popup__wrapper');
      if (registerKlaviyoPopup) {
        registerKlaviyoPopup.classList.add('show');
        //show modal
        document.body.classList.add('overflow-hidden');
        document.querySelector('.klaviyo-lead-capture-popup__container').classList.remove('animate-slideToBottomPopup');
        document.querySelector('.klaviyo-lead-capture-popup__container').classList.add('animate-slideFromBottomPopup');
      }
    }
  })
}

function bindAnnouncementTextClass() {
  const subscribedClientCookie = extractCookie('klaviyoClientSubscribed');
  if (!subscribedClientCookie) {
    const announcementBarText = document.querySelector('.promo-announcement-bar');
    if (announcementBarText) {
      announcementBarText.classList.add('promo-announcement-bar--guest');
      applyAnnouncementBarSlider();
    }
  }
}

document.addEventListener('DOMContentLoaded', function () {
  bindRegisterButton();
  bindAnnouncementTextClass();
});


// Intelligems price test: the dynamic price markup (theme, Nosto, previously viewed) is printed
// with the catalog price, so look up the price Intelligems assigned to the visitor instead.
const DYNAMIC_PRICE_AMOUNT_REGEX = /\d[\d,]*(?:\.\d+)?/;

function getIntelligemsDynamicPrice(element) {
  const igPrice = window.igData?.price;
  if (!igPrice) return null;

  const variantId = element.dataset.variantId;
  const productId =
    element.dataset.productId || element.closest('.price')?.querySelector('.igPrice[data-product-id]')?.dataset.productId;

  const amount = parseFloat(
    (variantId && igPrice.getPriceByVariantId?.(variantId)) ||
    (productId && igPrice.getMinPriceByProductId?.(productId))
  );

  return amount > 0 ? amount : null;
}

function showDynamicPrices() {
  if (window.hiddenSaleActive) return;

  //shows dynamic prices on product prices when qty is bigger then 2
  const getCartQuantity = () => {

    let cartQuantity = 0;

    // if (document.querySelector('.cart-count-bubble')) {
    //   cartQuantity = document.querySelector('.cart-count-bubble').dataset.items;
    // }
    if (document.querySelector('cart-drawer-items')) {
      cartQuantity = document.querySelector('cart-drawer-items').dataset.cartQty;
    }

    return parseInt(cartQuantity);
  };

  const cartQuantity = getCartQuantity();
  if (cartQuantity >= 2) {
    let discountValue = 1;
    let discountPercent = 0;

    if (cartQuantity >= 5) {
      discountValue = 0.8; // 20% off
      discountPercent = 20;
    } else if (cartQuantity === 4) {
      discountValue = 0.8; // 20% off
      discountPercent = 20;
    } else if (cartQuantity === 3) {
      discountValue = 0.85; // 15% off
      discountPercent = 15;
    } else if (cartQuantity === 2) {
      discountValue = 0.9; // 10% off
      discountPercent = 10;
    }

    // update html of prices

    const mainPriceContainers = document.querySelectorAll('.price__calculated');

    mainPriceContainers.forEach(element => {
      element.classList.remove('hidden');

      const regularPriceElement = element.querySelector('.price-item--normal-price span');
      if (regularPriceElement) {
        const intelligemsPrice = getIntelligemsDynamicPrice(element);
        if (intelligemsPrice) {
          const amount = intelligemsPrice.toLocaleString('en-US', {
            minimumFractionDigits: intelligemsPrice % 1 ? 2 : 0,
            maximumFractionDigits: 2
          });
          const text = regularPriceElement.textContent.replace(DYNAMIC_PRICE_AMOUNT_REGEX, amount);
          if (text !== regularPriceElement.textContent) regularPriceElement.textContent = text;
        }

        const regularPriceText = regularPriceElement.textContent;

        const regularPrice = intelligemsPrice || parseFloat(regularPriceText.replace(/[^0-9.]/g, ''));

        const discountedPrice = regularPrice * discountValue;

        const modifiedPriceElement = element.querySelector('.first-row--price');
        if (modifiedPriceElement) {
          const formattedPrice = `$${discountedPrice.toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          })}`;
          modifiedPriceElement.textContent = 'MXN' + formattedPrice;
        }

        const discountPercentElement = element.querySelector('.discount-percentage span');
        if (discountPercentElement) {
          discountPercentElement.textContent = discountPercent;
        }
      }
    });


    document.body.classList.add('show-dynamic-prices');
    document.body.classList.remove('hide-dynamic-prices');
  }
  else {
    // console.log('hide dynamic prices and show normal prices')
    document.body.classList.remove('show-dynamic-prices');
    document.body.classList.add('hide-dynamic-prices');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  showDynamicPrices();

  const refreshDynamicPrices = debounce(() => {
    showDynamicPrices();
  }, 100);

  // Recalculate once Intelligems has assigned the visitor's test prices
  window.onIgReady = window.onIgReady || [];
  window.onIgReady.push(refreshDynamicPrices);
  if (window.igLoaded) refreshDynamicPrices();

  const hasDynamicPriceNode = (node) => {
    if (!node || node.nodeType !== 1) return false;
    return node.matches?.('.price__calculated') || !!node.querySelector?.('.price__calculated');
  };

  const contentObserver = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'childList') {
        for (const addedNode of mutation.addedNodes) {
          if (hasDynamicPriceNode(addedNode)) {
            refreshDynamicPrices();
            return;
          }
        }
      }
    }
  });

  contentObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });

  const observeCartBubble = () => {
    const bubble = document.querySelector('.cart-count-bubble');
    if (!bubble) return;

    const bubbleObserver = new MutationObserver(() => {
      refreshDynamicPrices();
    });

    bubbleObserver.observe(bubble, {
      attributes: true,
      childList: true,
      characterData: true,
      subtree: true,
      attributeFilter: ['data-items'],
    });
  };

  observeCartBubble();

  document.addEventListener('cart:updated', refreshDynamicPrices);
  document.addEventListener('announcement-bar:updated', refreshDynamicPrices);
});


// Custom Tabs Functionality - Including BlazerSlider
function initializeCustomTabs() {
  const customTabsMenuItem = document.querySelectorAll('.custom-tabs__menu-item');
  const activeClass = 'active';

  customTabsMenuItem.forEach((tabItem) => {
    tabItem.addEventListener('click', function () {
      if (this.classList.contains(activeClass)) return;

      const customTabs = this.closest('.custom-tabs');

      // Remove current active class
      const prevTabItem = this.parentElement.querySelector('.' + activeClass);
      if (prevTabItem) {
        const prevTabId = prevTabItem.dataset.collection;
        const prevTabContent = customTabs.querySelector(`#custom-tabs__slide-item-${prevTabId}`);
        prevTabItem.classList.remove(activeClass);
        prevTabContent.classList.remove(activeClass);
      }

      // Activate the current clicked tab menu item
      this.classList.add(activeClass);

      const currentTabId = this.dataset.collection;
      const currentTab = customTabs.querySelector(`#custom-tabs__slide-item-${currentTabId}`);
      if (currentTab) currentTab.classList.add(activeClass);

      // Initialize the slider if it exists and is not yet initialized
      const slider = customTabs.querySelector('.blaze-slider--bestSellers.active');
      if (slider && !slider.classList.contains('slider-initialized')) {
        initializeSlider(slider);
      }

      // Menu Drawer - Close Submenu
      const menuDrawerOpen = document.querySelector('.menu-drawer__menu.submenu-open');
      if (menuDrawerOpen) {
        MenuDrawer.prototype.closeSubmenu(menuDrawerOpen.querySelector('details[open]'));
      }
    });
  });
}

initializeCustomTabs();

// Bundle info in cart
function initBundleInfoLogic() {
  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('.cart-item_bundle_extra-info .toggle-info');
    if (!toggle) return;

    toggle.closest('.cart-item_bundle_extra-info')?.classList.toggle('show-info');
  });
}

initBundleInfoLogic();
// END bundle info in cart

// Helper functions for working with cookies
function setCookie(name, value) {
  document.cookie = `${name}=${value};path=/`;
}
function getCookie(name) {
  var cookieValue = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
  return cookieValue ? cookieValue.pop() : null;
}

// Search ToolTip - Show + Hide after 5s
class SearchToolTip {
  constructor() {
    this.bindSearchTooltip();
  }

  getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  }

  setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000)); // days * hours * minutes * seconds * milliseconds
    const expires = "expires=" + date.toUTCString();
    document.cookie = `${name}=${value};${expires};path=/`;
  }

  toggleSearchTooltip(tooltips, show) {
    tooltips.forEach((tooltip) => {
      if (show) {
        tooltip.classList.add('show');

        const closeButton = tooltip.querySelector('.header-search-tooltip__close');
        if (closeButton) {
          closeButton.addEventListener('click', (event) => {
            const searchToolTip = event.target.closest('.header-search-tooltip');
            if (searchToolTip) {
              searchToolTip.classList.remove('show');
            }
          });
        }
      } else {
        tooltip.classList.remove('show');
      }
    });
  }

  bindSearchTooltip() {
    const searchTooltipViewed = this.getCookie('searchTooltipViewed');

    if (!searchTooltipViewed) {
      const searchTooltips = document.querySelectorAll('.header-search-tooltip');

      if (searchTooltips.length > 0) {
        this.toggleSearchTooltip(searchTooltips, true);

        setTimeout(() => {
          this.toggleSearchTooltip(searchTooltips, false);
          this.setCookie('searchTooltipViewed', 'true', 1);
        }, 5000);
      }
    }
  }
}

const searchToolTip = new SearchToolTip();

//script for search drawer search icon
document.addEventListener('DOMContentLoaded', function () {
  document.querySelector('.menu-drawer__search').addEventListener('click', function () {
    document.querySelector('.menu-drawer__close-btn').click();
    document.querySelector('.bottom-island__content--icon.bottom-island__search-btn').click();

    //remove search bar animation
    setTimeout(() => {
      let drawerMenuSearchBar = document.querySelector('.menu-drawer__search');
      if (drawerMenuSearchBar) drawerMenuSearchBar.classList.remove('activate-animation');
    }, 200);
  });
});

// reload cart nosto recomandations

let alreadyUpdatingCartRec = false;

function syncCartRecommendationsFromDrawer() {
  const source = document.querySelector('#CartDrawer #minicart-rec-nosto-july-26');
  const target = document.querySelector('.cart__recomandations-wrapper');
  if (!source || !target) return false;

  target.replaceChildren(source.cloneNode(true));
  return true;
}

function reloadCartRecomandations() {
  if (alreadyUpdatingCartRec) return;
  alreadyUpdatingCartRec = true;

  // On PDP, reloading Nosto globally refreshes tab content blocks
  // (e.g. productpage-nosto-june-26 / previously-viewed-pdp).
  // Skip global reload there to keep those sections stable on add-to-cart.
  if (document.querySelector('#productpage-nosto-june-26') || document.querySelector('#previously-viewed-pdp')) {
    alreadyUpdatingCartRec = false;
    return;
  }

  if (document.querySelector('.drawer-suggest-with-nosto-july-26')) {
    // Reload Recomandations
    if (window.location.href.includes('/cart')) {
      if (document.querySelector('cart-drawer #minicart-rec-nosto-july-26')) {
        syncCartRecommendationsFromDrawer();
      } else {
        let checkCount = 0;
        const maxChecks = 60;
        let nostoTimer = setInterval(function () {
          checkCount++;
          if (window.nostojs) {
            clearInterval(nostoTimer);

            nostojs(api => {
              api.loadRecommendations();
              setTimeout(() => {
                syncCartRecommendationsFromDrawer();
                if (typeof window.okeWidgetApi?.initAllWidgets === 'function') {
                  window.okeWidgetApi.initAllWidgets();
                }
                // showDynamicPrices();
              }, 500)
            });

          } else if (checkCount >= maxChecks) {
            clearInterval(nostoTimer);
          }
        }, 500);


      }
    } else {
      nostojs(api => {
        api.loadRecommendations();
        setTimeout(() => {
          // showDynamicPrices();
          // showDynamicPrices();
          if (typeof window.okeWidgetApi?.initAllWidgets === 'function') {
            window.okeWidgetApi.initAllWidgets();
          }
        }, 500)
      });
    }
  }

  alreadyUpdatingCartRec = false;
  // showDynamicPrices();
  // showDynamicPrices();
}

// END reload cart nosto recomandations

// Intelligems price test on cart recommendations
// Nosto (and the Liquid fallback) print "Agregar - MXN$..." with the catalog price,
// so rewrite the label with the price Intelligems assigned to the visitor.

const CART_REC_ATC_SELECTOR = '.drawer-suggest-with-nosto-july-26 .quick-add__submit';
const CART_REC_PRICE_REGEX = /MXN\s*\$?\s*[\d,]+(?:\.\d+)?/;

function formatIntelligemsPrice(amount) {
  return `MXN$${amount.toLocaleString('en-US', {
    minimumFractionDigits: amount % 1 ? 2 : 0,
    maximumFractionDigits: 2
  })}`;
}

function applyIntelligemsCartRecPrices() {
  const igPrice = window.igData?.price;
  if (typeof igPrice?.getPriceByVariantId !== 'function') return;

  document.querySelectorAll(CART_REC_ATC_SELECTOR).forEach((button) => {
    const variantId = button.form?.querySelector('input[name="id"]')?.value;
    if (!variantId) return;

    const amount = parseFloat(igPrice.getPriceByVariantId(variantId));
    if (!amount) return;

    const price = formatIntelligemsPrice(amount);
    const label = button.querySelector('span');

    if (label && CART_REC_PRICE_REGEX.test(label.textContent)) {
      const text = label.textContent.replace(CART_REC_PRICE_REGEX, price);
      if (text !== label.textContent) label.textContent = text;
    }

    if (button.dataset.content && CART_REC_PRICE_REGEX.test(button.dataset.content)) {
      button.dataset.content = button.dataset.content.replace(CART_REC_PRICE_REGEX, price);
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const refreshCartRecPrices = debounce(applyIntelligemsCartRecPrices, 100);

  window.onIgReady = window.onIgReady || [];
  window.onIgReady.push(refreshCartRecPrices);
  if (window.igLoaded) refreshCartRecPrices();

  const isCartRecNode = (node) =>
    node.nodeType === 1 && (node.closest('.drawer-suggest-with-nosto-july-26') || node.querySelector(CART_REC_ATC_SELECTOR));

  new MutationObserver((mutations) => {
    if (mutations.some((mutation) => [...mutation.addedNodes].some(isCartRecNode))) {
      refreshCartRecPrices();
    }
  }).observe(document.body, { childList: true, subtree: true });
});

// END Intelligems price test on cart recommendations

// video pause button on CAT videos
window.addEventListener('click', (e) => {
  if (!e.target.closest('.CAT__products')) return;

  if (e.target.closest('.pause-icon')) {
    let parent = e.target.closest('.promo-card-video')
    let video;
    let pauseIcon = parent.querySelector('.pause-icon');
    if (window.innerWidth > 768) {
      video = parent.querySelector('.video.mobile-hidden') || parent.querySelector('video');
    }
    else {
      video = parent.querySelector('.video.desktop-hidden') || parent.querySelector('video');
    }
    if (parent && video) {
      if (video.paused == true) {
        video.play();
        pauseIcon.src = 'https://cdn.shopify.com/s/files/1/0625/4631/3452/files/pause-icon-hp.svg?v=1760968424'
      }
      else {
        video.pause();
        pauseIcon.src = 'https://cdn.shopify.com/s/files/1/0625/4631/3452/files/play-icon.svg?v=1761060437'
      }
    }
  }
})

// if(!e.target.closest('.pause-icon')){ location.href='/collections/dossier-originals#coleccion-mariana' }

// END video pause button

// relocate to another page
window.addEventListener('click', (e) => {
  if (e.target.closest('[data-relocate-to]') && !e.target.closest('.pause-icon')) {
    let relocateLink = e.target.closest('[data-relocate-to]').dataset.relocateTo;
    window.location.href = relocateLink;
  }
})
// END relocate to another page

document.addEventListener('click', (e) => {
  const trigger = e.target.closest('.open-dialog-modal');
  if (!trigger) return;

  e.preventDefault();
  e.stopPropagation();

  const modalSelector = trigger.getAttribute('data-modal-target');
  if (!modalSelector) return;

  const modal = document.querySelector(modalSelector);
  if (!modal) return;

  modal.classList.add('show');
});

// Drag Scroll - START
function initDragScroll(root = document) {
  const DRAG_THRESHOLD = 4;
  const INERTIA_START_VELOCITY = 0.02;
  const INERTIA_STOP_VELOCITY = 0.015;
  const INERTIA_FRICTION_PER_FRAME = 0.94;
  const MAX_INERTIA_FRAME_MS = 40;

  root.querySelectorAll('.js-drag-scroll:not([data-drag-scroll-ready])').forEach((element) => {
    element.dataset.dragScrollReady = 'true';

    const axis = element.dataset.dragScrollAxis === 'y' ? 'y' : 'x';
    if (!element.style.touchAction) {
      element.style.touchAction = axis === 'x' ? 'pan-y' : 'pan-x';
    }

    const scrollPosKey = axis === 'x' ? 'scrollLeft' : 'scrollTop';
    const scrollSizeKey = axis === 'x' ? 'scrollWidth' : 'scrollHeight';
    const clientSizeKey = axis === 'x' ? 'clientWidth' : 'clientHeight';
    const pointerPosKey = axis === 'x' ? 'clientX' : 'clientY';

    let startScroll = 0;
    let startPointerPos = 0;
    let isDown = false;
    let hasDragged = false;
    let activePointerId = null;
    let velocity = 0;
    let lastScrollPos = 0;
    let lastMoveTime = 0;
    let inertiaRafId = null;

    const getScrollPos = () => element[scrollPosKey];
    const setScrollPos = (value) => {
      element[scrollPosKey] = value;
    };
    const getMaxScroll = () => Math.max(0, element[scrollSizeKey] - element[clientSizeKey]);

    const stopInertia = () => {
      if (inertiaRafId !== null) {
        cancelAnimationFrame(inertiaRafId);
        inertiaRafId = null;
      }
    };

    const startInertia = () => {
      if (Math.abs(velocity) < INERTIA_START_VELOCITY) return;

      stopInertia();

      let previousFrameTime = performance.now();

      const step = (now) => {
        const deltaTime = Math.min(MAX_INERTIA_FRAME_MS, now - previousFrameTime);
        previousFrameTime = now;

        // Apply time-scaled friction so it feels consistent across frame rates.
        velocity *= Math.pow(INERTIA_FRICTION_PER_FRAME, deltaTime / 16.67);

        if (Math.abs(velocity) < INERTIA_STOP_VELOCITY) {
          stopInertia();
          return;
        }

        const maxScroll = getMaxScroll();
        const currentPos = getScrollPos();
        const nextPos = Math.max(0, Math.min(maxScroll, currentPos + velocity * deltaTime));

        if (nextPos === currentPos) {
          stopInertia();
          return;
        }

        setScrollPos(nextPos);
        inertiaRafId = requestAnimationFrame(step);
      };

      inertiaRafId = requestAnimationFrame(step);
    };

    const onEnd = (event) => {
      if (!isDown) return;
      if (event && event.pointerId !== activePointerId) return;

      isDown = false;

      if (activePointerId !== null) {
        if (element.hasPointerCapture?.(activePointerId)) {
          element.releasePointerCapture?.(activePointerId);
        }
        activePointerId = null;
      }

      element.classList.remove('is-drag-scrolling');

      if (hasDragged) {
        startInertia();
      }

      requestAnimationFrame(() => {
        hasDragged = false;
      });
    };

    element.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'mouse' && event.button !== 0) return;

      stopInertia();
      isDown = true;
      hasDragged = false;
      activePointerId = event.pointerId;
      velocity = 0;

      startPointerPos = event[pointerPosKey];
      startScroll = getScrollPos();
      lastScrollPos = getScrollPos();
      lastMoveTime = performance.now();
    });

    element.addEventListener('pointermove', (event) => {
      if (!isDown || event.pointerId !== activePointerId) return;

      const dragDistance = Math.abs(event[pointerPosKey] - startPointerPos);

      if (!hasDragged && dragDistance > DRAG_THRESHOLD) {
        hasDragged = true;
        element.classList.add('is-drag-scrolling');
        // Capture the pointer only once a real drag starts, so plain clicks
        // still reach links/buttons (setPointerCapture retargets the click).
        element.setPointerCapture?.(event.pointerId);
      }

      if (!hasDragged) return;

      const pointerDelta = event[pointerPosKey] - startPointerPos;
      setScrollPos(startScroll - pointerDelta);

      const now = performance.now();
      const currentScrollPos = getScrollPos();
      const deltaTime = now - lastMoveTime;
      if (deltaTime > 0) {
        // Velocity in px/ms used for inertial scrolling on release.
        velocity = (currentScrollPos - lastScrollPos) / deltaTime;
      }
      lastScrollPos = currentScrollPos;
      lastMoveTime = now;

      event.preventDefault();
    }, { passive: false });

    element.addEventListener('pointerup', onEnd);
    element.addEventListener('pointercancel', onEnd);

    // Prevent native anchor/image drag so pointer-drag always scrolls.
    element.addEventListener('dragstart', (event) => {
      event.preventDefault();
    });

    element.addEventListener('click', (event) => {
      if (!hasDragged) return;

      event.preventDefault();
      event.stopPropagation();
    }, true);
  });
}

function observeDragScrollMounts() {
  if (!document.body || document.body.dataset.dragScrollObserverReady === 'true') return;

  document.body.dataset.dragScrollObserverReady = 'true';

  const observer = new MutationObserver((mutations) => {
    let shouldScan = false;

    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== Node.ELEMENT_NODE) return;

        if (node.matches?.('.js-drag-scroll') || node.querySelector?.('.js-drag-scroll')) {
          shouldScan = true;
        }
      });
    });

    if (shouldScan) {
      initDragScroll(document);
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initDragScroll(document);
    observeDragScrollMounts();
  });
} else {
  initDragScroll(document);
  observeDragScrollMounts();
}

document.addEventListener('shopify:section:load', (event) => {
  initDragScroll(event.target);
});
// Drag Scroll - END


// Polly Pocket product cards: restart the hover video each time the card is hovered or pressed
function cardHoverVideo(event, shouldPlay) {
  const wrapper = event.target.closest?.('.card-wrapper');
  const video = wrapper?.querySelector('.card__hover-video');
  if (!video) return;

  if (shouldPlay) {
    if (!video.paused) return;
    video.currentTime = 0;
    video.play().catch(() => {});
  } else if (!wrapper.contains(event.relatedTarget)) {
    video.pause();
    video.currentTime = 0;
  }
}

// Product card autoplay videos: only play while on screen. Videos left playing off screen keep the
// compositor busy decoding and delay the next paint after every interaction (INP), especially once
// infinite scroll has loaded the whole grid. Videos are registered on their first `play` event, which
// also covers cards added by infinite scroll.
if ('IntersectionObserver' in window) {
  const cardVideoObserver = new IntersectionObserver((entries) => {
    entries.forEach(({ target, isIntersecting }) => {
      if (isIntersecting) {
        target.play().catch(() => {});
      } else {
        target.pause();
      }
    });
  });
  const cardVideoSelector = '.card-wrapper video:not(.card__hover-video)';
  const observedCardVideos = new WeakSet();
  const observeCardVideo = (video) => {
    if (observedCardVideos.has(video) || !video.matches?.(cardVideoSelector)) return;
    observedCardVideos.add(video);
    cardVideoObserver.observe(video);
  };

  document.querySelectorAll(cardVideoSelector).forEach(observeCardVideo);
  document.addEventListener('play', (event) => observeCardVideo(event.target), true);
}

document.addEventListener('mouseover', (event) => cardHoverVideo(event, true));
document.addEventListener('mouseout', (event) => cardHoverVideo(event, false));
document.addEventListener('touchstart', (event) => cardHoverVideo(event, true), { passive: true });
document.addEventListener('touchend', (event) => cardHoverVideo(event, false), { passive: true });
document.addEventListener('touchcancel', (event) => cardHoverVideo(event, false), { passive: true });

// Polly Pocket custom mouse cursor logic for desktop viewports

// add-to-cart / notify-me buttons: the doll hops on desktop, a star burst plays alongside
const POLLY_ATC_SELECTOR = '.product-form__submit, .quick-add__submit, .product-layering__add-to-cart, .item-atc, button[name="add"], .js-back-in-stock, .bis-prev';
const POLLY_STAR_COLORS = ['#a48cf0', '#f3a0c8', '#ffd96b', '#8fd3c9', '#c9a7ff'];

// Spawns a handful of small stars inside `container` (which must be positioned) and removes them when done.
// `spread` is the arc in radians the stars fly out over, centred straight up; 2*PI is a full ring.
function pollyStarBurst(container, { count = 6, spread = Math.PI * 1.4, minDist = 34, maxDist = 64 } = {}) {
  for (let i = 0; i < count; i++) {
    const star = document.createElement('span');
    star.className = 'polly-pocket_click-doll__star';
    const angle = (-Math.PI / 2) + (Math.random() - 0.5) * spread;
    const dist = minDist + Math.random() * (maxDist - minDist);
    star.style.setProperty('--dx', `${Math.cos(angle) * dist}px`);
    star.style.setProperty('--dy', `${Math.sin(angle) * dist}px`);
    star.style.setProperty('--rot', `${(Math.random() - 0.5) * 240}deg`);
    star.style.setProperty('--size', `${7 + Math.random() * 7}px`);
    star.style.setProperty('--color', POLLY_STAR_COLORS[i % POLLY_STAR_COLORS.length]);
    star.addEventListener('animationend', () => star.remove(), { once: true });
    container.appendChild(star);
  }
}

function pollyPocketCursorLogic() {

  if (window.innerWidth < 768) {
    return
  }
  // show random doll
  let handles_list = ['marshmallow-mood', 'pistachio-swirl', 'berry-daydream'];

  let randomHandle = handles_list[Math.floor(Math.random() * handles_list.length)];
  if (location.href.includes('daydream')) {
    randomHandle = handles_list[2]
  }
  else if (location.href.includes('swirl')) {
    randomHandle = handles_list[1]
  }
  else if (location.href.includes('llow-mood')) {
    randomHandle = handles_list[0]
  }

  document.body.classList.add(`polly-cursor_${randomHandle}`)

  // cursor companion: the doll trails the pointer with a bit of weight,
  // leans into her direction of travel, bobs while running and hops on click.

  const doll = document.querySelector('.polly-pocket_click-doll');
  if (!doll) return;
  const figure = doll.querySelector('.polly-pocket_click-doll__figure');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Offset coordinates (pixels to the right and down from the cursor point)
  const offsetX = 28;
  const offsetY = 20;
  const handOffsetX = 29;
  const handOffsetY = 21;

  // what she reacts to (mirrors the elements the Polly cursor icon already targets)
  const CARD_SELECTOR = '.card, .card-wrapper, .promo-card-it-factor, .promo-card-mgk';
  const CTA_SELECTOR = '.button, .quick-add__submit, .product-form__submit, .shopify-payment-button__button, button[type="submit"], .polly-doll_button';
  const HAND_SELECTOR = 'a, button, .close-btn, .no-thanks-btn, #floating-discount-button, summary, .grid__item, .hero-banner, .product-card-featured_container, .search-filters__item, .polly-pocket_search_button';
  const INPUT_SELECTOR = 'input, textarea, select, [contenteditable="true"], .field__input, .search__input';
  const OVERLAY_SELECTOR = 'cart-drawer, cart-notification, modal-dialog, product-modal, quick-add-modal, details-modal, dialog, [role="dialog"], .predictive-search, .menu-drawer, .cart-drawer, cart-items, .cart-items, .klaviyo-lead-capture-popup__wrapper';

  // idle timings
  const IDLE_FIDGET_MS = 4000;
  const IDLE_HIDE_MS = 10000;

  // tuning
  const FOLLOW_TAU = 0.11;      // seconds for the doll to close ~63% of the gap to the pointer
  const LEAN_PER_PX_S = 0.022;  // degrees of lean per px/s of horizontal speed
  const LEAN_MAX = 16;          // degrees
  const LEAN_STIFFNESS = 140;   // spring toward the target lean
  const LEAN_DAMPING = 14;      // pendulum settle
  const BOB_MAX_PX = 5;         // footstep bounce height at full speed
  const BOB_FULL_SPEED = 900;   // px/s at which the bob reaches full height
  const STEPS_PER_SECOND = 5;

  const target = { x: 0, y: 0 };
  const pos = { x: 0, y: 0 };
  let lean = 0, leanVelocity = 0;
  let bobAmp = 0, bobPhase = 0;
  let lastFrame = 0, rafId = 0, started = false;

  function frame(now) {
    const dt = Math.min((now - lastFrame) / 1000, 0.05) || 0.016;
    lastFrame = now;

    // 1. follow with lag
    const k = 1 - Math.exp(-dt / FOLLOW_TAU);
    const prevX = pos.x, prevY = pos.y;
    pos.x += (target.x - pos.x) * k;
    pos.y += (target.y - pos.y) * k;
    const vx = (pos.x - prevX) / dt;
    const vy = (pos.y - prevY) / dt;
    const speed = Math.hypot(vx, vy);

    // 2. lean into the direction of travel, settle like a pendulum
    const targetLean = Math.max(-LEAN_MAX, Math.min(LEAN_MAX, vx * LEAN_PER_PX_S));
    leanVelocity += ((targetLean - lean) * LEAN_STIFFNESS - leanVelocity * LEAN_DAMPING) * dt;
    lean += leanVelocity * dt;

    // 3. footstep bob while moving, fades out when she stops
    const wantedAmp = Math.min(speed / BOB_FULL_SPEED, 1) * BOB_MAX_PX;
    bobAmp += (wantedAmp - bobAmp) * Math.min(dt * 10, 1);
    bobPhase += dt * Math.PI * 2 * STEPS_PER_SECOND;
    const bob = Math.abs(Math.sin(bobPhase)) * bobAmp;

    doll.style.transform = `translate3d(${pos.x}px, ${pos.y}px, 0)`;
    figure.style.transform = `translateY(${-bob}px) rotate(${lean}deg)`;

    const settled = Math.abs(target.x - pos.x) < 0.3 && Math.abs(target.y - pos.y) < 0.3
      && Math.abs(lean) < 0.05 && Math.abs(leanVelocity) < 0.5 && bobAmp < 0.05;
    if (settled) {
      pos.x = target.x; pos.y = target.y; lean = 0; leanVelocity = 0; bobAmp = 0;
      doll.style.transform = `translate3d(${pos.x}px, ${pos.y}px, 0)`;
      figure.style.transform = '';
      rafId = 0;
      return;
    }
    rafId = requestAnimationFrame(frame);
  }

  let fidgetTimer = 0, hideTimer = 0;

  function setState(name, on) {
    doll.classList.toggle(name, on);
  }

  function goIdle() {
    setState('is-idle', true);
  }

  function hide() {
    setState('is-idle', false);
    setState('is-active', false);
  }

  window.addEventListener('mousemove', (e) => {
    const el = e.target instanceof Element ? e.target : null;
    const overOverlay = !!(el && el.closest(OVERLAY_SELECTOR));
    const overInput = !overOverlay && !!(el && el.closest(INPUT_SELECTOR));
    const overHand = !overOverlay && !overInput && !!(el && el.closest(HAND_SELECTOR));
    const overCta = !overOverlay && !overInput && !!(el && el.closest(CTA_SELECTOR));
    const overCard = !overOverlay && !overInput && !overCta && !!(el && el.closest(CARD_SELECTOR));

    target.x = e.clientX + (overHand ? handOffsetX : offsetX);
    target.y = e.clientY + (overHand ? handOffsetY : offsetY);

    if (!started) {
      // first move: appear where the pointer is instead of flying in from the corner
      started = true;
      pos.x = target.x; pos.y = target.y;
      doll.style.transform = `translate3d(${pos.x}px, ${pos.y}px, 0)`;
    }

    // stay out of the way of the cart drawer, modals and the search dropdown
    clearTimeout(fidgetTimer);
    clearTimeout(hideTimer);
    setState('is-idle', false);
    setState('is-active', !overOverlay);

    if (reducedMotion) {
      doll.style.transform = `translate3d(${target.x}px, ${target.y}px, 0)`;
      return;
    }

    setState('is-over-cta', overCta);
    setState('is-over-card', overCard);

    if (!overOverlay) {
      fidgetTimer = setTimeout(goIdle, IDLE_FIDGET_MS);
      hideTimer = setTimeout(hide, IDLE_HIDE_MS);
    }

    if (!rafId) {
      lastFrame = performance.now();
      rafId = requestAnimationFrame(frame);
    }
  });

  // fade out when the pointer leaves the window, back on the next move
  document.addEventListener('mouseleave', () => {
    clearTimeout(fidgetTimer);
    clearTimeout(hideTimer);
    hide();
  });

  // 4. add-to-cart click: squash while held, hop + star burst on release
  if (reducedMotion) return;

  let lastBurst = 0;

  function burst() {
    const now = performance.now();
    if (now - lastBurst < 250) return;   // don't pile up stars on rapid clicks
    lastBurst = now;
    pollyStarBurst(doll);   // mostly upward, from her feet
  }

  window.addEventListener('mousedown', (e) => {
    if (e.button !== 0) return;
    if (!(e.target instanceof Element) || !e.target.closest(POLLY_ATC_SELECTOR)) return;
    doll.classList.remove('is-hopping');
    doll.classList.add('is-pressed');
  });

  window.addEventListener('mouseup', (e) => {
    if (e.button !== 0 || !doll.classList.contains('is-pressed')) return;
    doll.classList.remove('is-pressed');
    // restart the hop animation even if the previous one is still running
    void doll.offsetWidth;
    doll.classList.add('is-hopping');
    burst();
  });

  doll.addEventListener('animationend', (e) => {
    if (e.target.tagName === 'IMG') doll.classList.remove('is-hopping');
  });
}

function pollyPocketSearchButtons() {
  document.querySelectorAll('.polly-pocket_search_buttons').forEach((toolbar) => {
    const searchInput = toolbar.closest('.main-search-page')?.querySelector('.search__input')
      || document.querySelector('#predictive-search__header .search__input');
    if (searchInput) initializePollyPocketSearchButtons(toolbar, searchInput);
  });
}

function initializePollyPocketSearchButtons(toolbar, searchInput) {
  const isHeaderSearch = Boolean(toolbar.closest('.header__search'));
  const searchDetails = toolbar.closest('details');
  const isMobile = () => window.innerWidth <= 768;
  let savedScrollY = 0;
  let inputWasFocused = false;
  let raisedByTyping = false;
  let typingTimer = 0;

  function preventTouchScroll(e) {
    if (e.target === searchInput) return;
    // Allow native touch scrolling/dragging inside the search results panel.
    if (e.target instanceof Element && e.target.closest('.search-filter-modal')) return;
    e.preventDefault();
  }

  function lockScroll() {
    savedScrollY = window.scrollY;
    document.documentElement.classList.add('scroll-locked');
    document.body.classList.add('scroll-locked');
    window.addEventListener('touchmove', preventTouchScroll, { passive: false });
  }

  function unlockScroll() {
    document.documentElement.classList.remove('scroll-locked');
    document.body.classList.remove('scroll-locked');
    window.removeEventListener('touchmove', preventTouchScroll);
    window.scrollTo(0, savedScrollY);
  }

  function lowerDolls() {
    const activeClasses = [...toolbar.classList].filter((className) => className.includes('clicked'));
    toolbar.classList.remove(...activeClasses);
  }

  function raiseDoll(handle) {
    const clickedClass = `${handle}-clicked`;
    if (toolbar.classList.contains(clickedClass)) return;

    lowerDolls();
    toolbar.classList.add(clickedClass);
  }

  toolbar.addEventListener('pointerdown', () => {
    inputWasFocused = document.activeElement === searchInput;
  });

  toolbar.addEventListener('click', (e) => {
    const targetElement = e.target instanceof Element ? e.target : null;
    const button = targetElement?.closest('.polly-pocket_search_button[data-handle]');
    if (!button) return;

    e.preventDefault();
    if (isHeaderSearch && isMobile() && inputWasFocused) searchInput.focus();

    const handle = button.dataset.handle;
    if (targetElement.closest('.redirect-btn')) {
      location.href = `${Shopify.routes.root}products/${handle}`;
      return;
    }

    const wasOpen = toolbar.classList.contains(`${handle}-clicked`);
    if (wasOpen && isMobile()) {
      lowerDolls();
      return;
    }

    raiseDoll(handle);
    raisedByTyping = false;
  });

  const dollKeywords = [
    { handle: 'marshmallow-mood', words: ['marshmallow', 'mood', 'polly', 'pocket'] },
    { handle: 'pistachio-swirl', words: ['pistachio', 'swirl'] },
    { handle: 'berry-daydream', words: ['berry', 'daydream'] },
  ];

  searchInput.addEventListener('input', () => {
    clearTimeout(typingTimer);
    typingTimer = setTimeout(() => {
      const text = searchInput.value.trim().toLowerCase();
      const match = text.length >= 3
        ? dollKeywords.find((doll) => doll.words.some((word) => text.includes(word)))
        : null;

      if (match) {
        raiseDoll(match.handle);
        raisedByTyping = true;
      } else if (raisedByTyping) {
        lowerDolls();
        raisedByTyping = false;
      }
    }, 150);
  });

  const canHover = window.matchMedia('(hover: hover)');
  toolbar.addEventListener('mouseover', (e) => {
    const targetElement = e.target instanceof Element ? e.target : null;
    if (isMobile() || !canHover.matches || targetElement?.closest('.redirect-btn')) return;

    const button = targetElement?.closest('.polly-pocket_search_button[data-handle]');
    if (button) button.click();
  });

  function togglePollyButtons() {
    if (!isHeaderSearch || !isMobile()) return;

    const modalOpen = !searchDetails || searchDetails.open;
    if (!modalOpen) {
      toolbar.style.display = 'none';
      toolbar.style.transform = 'translateY(0px)';
      return;
    }

    toolbar.style.display = 'flex';

    const viewport = window.visualViewport;
    const keyboardOpen = !!viewport
      && viewport.height < window.screen.height * .7
      && document.activeElement === searchInput;
    const offset = keyboardOpen ? window.innerHeight - viewport.height - viewport.offsetTop : 0;
    toolbar.style.transform = offset > 0 ? `translateY(-${offset}px)` : 'translateY(0px)';
  }

  if (isHeaderSearch) {
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', togglePollyButtons);
      window.visualViewport.addEventListener('scroll', togglePollyButtons);
    }
    if (searchDetails) searchDetails.addEventListener('toggle', togglePollyButtons);
    window.addEventListener('resize', togglePollyButtons);

    searchInput.addEventListener('focus', () => {
      if (isMobile()) {
        lockScroll();
        togglePollyButtons();
      } else {
        toolbar.style.display = 'flex';
      }
    });

    searchInput.addEventListener('blur', () => {
      setTimeout(() => {
        if (document.activeElement !== searchInput && isMobile()) {
          unlockScroll();
          togglePollyButtons();
        }
      }, 100);
    });

    document.addEventListener('click', (e) => {
      if (!(e.target instanceof Element)) return;

      // Match the search buttons before isMobile(): reading window.innerWidth forces a layout on every tap (INP)
      const opensSearch = !!e.target.closest('.bottom-island__search-btn');
      if (!opensSearch && !e.target.closest('.search-modal__close-button')) return;
      if (!isMobile()) return;

      const meta = document.querySelector('meta[name="viewport"]');
      if (!meta) return;

      const baseContent = 'width=device-width,initial-scale=1';
      meta.content = opensSearch ? `${baseContent},interactive-widget=resizes-content` : baseContent;
    });
  }
}

// Initialization trigger
window.addEventListener("DOMContentLoaded", () => {
  pollyPocketSearchButtons();
  pollyPocketCursorLogic();
});
// End Polly Pocket custom mouse cursor logic for desktop viewports
